var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-no-repeat bg-cover bg-bottom px-6 py-4 rounded-lg text-white relative z-0 overflow-hidden shadow-custom",style:({
    backgroundImage: _vm.image,
    minHeight: '150px',
  })},[_c('div',{staticClass:"z-10 relative"},[_c('h1',{staticClass:"text-4xl font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-xl mt-2.5 max-w-2xl"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }